import React from "react";
import { ColumnDef } from "@tanstack/react-table";
import { usePartnerStore } from "@store/partnerStore";
import { Store } from "lucide-react";
import { formatNumber } from "@utils/formatNumber";

export const DashboardMerchantTableColumns = (): ColumnDef<any>[] => {

  const { currency } = usePartnerStore();

  return [
    {
      accessorKey: "merchantName",
      header: "Merchant Name",
      cell: ({ row }) => {
        return <div className="flex items-center gap-2"><Store className="w-4 h-4 text-gray-600" /> {row.original.merchantName}</div>;
      },
    },
    {
      accessorKey: "distributorAdsRevenuePerMerchant",
      header: "Ads Revenue",
      cell: ({ row }) => {
        return <div>{formatNumber(row.original.distributorAdsRevenuePerMerchant)} <span className="text-gray-500">{currency}</span></div>;
      },
    },
    {
      accessorKey: "merchantRevenuePerMerchant",
      header: "Merchant Revenue",
      cell: ({ row }) => {
        return <div>{formatNumber(row.original.merchantRevenuePerMerchant)} <span className="text-gray-500">{currency}</span></div>;
      },
    },

    {
      accessorKey: "ordersGeneratedPerMerchant",
      header: "Orders",
      cell: ({ row }) => {
        return <div>{row.original.ordersGeneratedPerMerchant}</div>;
      },
    },

    {
      accessorKey: "totalImpressionsPerMerchant",
      header: "Impressions",
      cell: ({ row }) => {
        return <div>{row.original.totalImpressionsPerMerchant}</div>;
      },
    },

    {
      accessorKey: "totalClicksPerMerchant",
      header: "Clicks",
      cell: ({ row }) => {
        return <div>{row.original.totalClicksPerMerchant}</div>;
      },
    },

  ];
};
